import React from 'react';
import { connect } from 'react-redux';
import {Link, browserHistory} from 'react-router';
import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
import {TrangChu} from 'api';
import TextTruncate from 'react-text-truncate';
import classnames from 'classnames';

let bellIcon = require('assets/images/bell.png');

class NotificationTTT extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      notifyCount: 0,
      data: [],
      page: 0,
      hasMore: false,
      onOpen: false
    }
  }

  componentDidMount() {
    this.getNotify();
    this.getUnreadNotify();
  }

  getUnreadNotify() {
    TrangChu.actions.getUnreadNotify.request().then(res => {
      if (this.refs.notify) {
        if (res.data) {
          this.setState({notifyCount: res.data});
        }
      }
    }).catch(err => {

    });
  }

  getNotify() {
    TrangChu.actions.getThongBao.request(null, {size:3, page: this.state.page}).then(res => {
      if (this.refs.notify) {
        let state = this.state;
        if (res.data && res.data._embedded) {
          state.data = [...res.data._embedded.thongBaos];
          state.totalElements = res.data.page.totalElements;
        } else {
          state.data = [];
          state.notifyCount = 0;
        }
        this.setState({...state});
      }
    }).catch(err => {

    });
  }

  async openNoiti() {
    await this.setState(prevState => ({
      onOpen: !prevState.onOpen
    }));
    if (this.state.onOpen) {
      this.getNotify();
    }
  }

  handleClickNoti(id) {
    browserHistory.push(`/thanh-tra/chi-tiet-thong-bao/${id}`);
  }

  checkCountNoti() {
    if (this.state.notifyCount > 0 && this.state.notifyCount < 100) {
      return (
        <span className="menu-notification bell">{this.state.notifyCount}</span>
      )
    } else if (this.state.notifyCount > 99) {
      return (
        <span className="menu-notification bell">99<sup>+</sup></span>
      )
    }
  }

  render() {
    return (
      <div ref='notify'>
        <Popover
          interactionKind={PopoverInteractionKind.CLICK}
          popoverClassName={
            classnames('pt-popover-content-sizing notify-box', {
              'arrow-unread': this.state.data.length && !this.state.data[0].daXem
            })}
          position={Position.BOTTOM}
          className="mt10"
        >
          <Link className="notification-wrap" onClick={this.openNoiti.bind(this)}>
            <img src={bellIcon} alt="bell-icon" className="bell-ico"/>
            {
              this.checkCountNoti()
            }
          </Link>
          <div className="notify-content">
            <ul>
              {
                this.state.data && this.state.data.length > 0 ? (
                  <div>
                    {this.state.data.map((item, index) => {
                      return (
                        <li className={classnames('ttt-notification', {'unread': item.daXem === false })} key={index}>
                          <Link className='notification-item' onClick={this.handleClickNoti.bind(this, item.thongBaoId)}>
                            <div className='pd10'>
                            <TextTruncate
                              line={3}
                              truncateText="…"
                              text={item.content}
                            />
                            </div>
                          </Link>
                        </li>
                      )
                    })}
                    {
                      this.state.totalElements > 3 &&
                      <Link to='/thanh-tra/danh-sach-thong-bao' className="btn-action btn-green jt-center col-100">Xem tất cả thông báo<span className="tt-arrow-right"></span></Link>
                    }

                  </div>
                )
                 :
                <li className="unlink" key={1}>Chưa có thông báo mới nào!</li>
              }
            </ul>
          </div>
        </Popover>
      </div>
    );
  }
}
function bindStateToProps(state) {
  return {
    notifyData: state.duLieuHeThong.notify
  };
}

export default connect(bindStateToProps)(NotificationTTT);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/NotificationTTT.jsx